import React, { FC } from 'react';
import styled from 'styled-components';

import BaseCard, { IBaseCard } from '@ui/atoms/BaseCard';
import BasicText from '@ui/atoms/BasicText';
import Button, { IButtonProps } from '@ui/atoms/Button';
import FlexColumn, { IFlexColumn } from '@ui/atoms/FlexColumn';
import WYSIWYGContent from '@ui/atoms/WYSIWYGContent';

import IconHeader from '@ui/molecules/IconHeader';

import aligned from '@ui/styled/Aligned';
import padded from '@ui/styled/Padded';

import theme from '@theme/FolxTheme';

interface IMessagesCardProps {
	cta: string;
	description: string;
	header: string;
	href: string;
	Icon: string;
	list: string;
	subheader: string;
}

const PaddedCard = padded<IBaseCard>(BaseCard);
const PaddedColumn = padded<IFlexColumn>(FlexColumn);
const AlignedButton = aligned<IButtonProps>(Button);

const BorderedColumn = styled(PaddedColumn)`
	border-top: ${theme.colors.darkGray} solid 1px;
`;

const MessagesCard: FC<IMessagesCardProps> = ({
	cta,
	description,
	header,
	href,
	Icon,
	list,
	subheader,
}) => {
	return (
		<PaddedCard borderless padding="smmd" paddingBottom="lg" bgColor="white" radius="xl">
			<FlexColumn gap="sm">
				<IconHeader Icon={Icon} title={header} description={subheader} />
				<AlignedButton label={cta} href={href} alignSelf="center" />
				<BorderedColumn gap="xs" paddingTop="sm">
					<BasicText variant="fineprintBold">{description}</BasicText>
					<WYSIWYGContent dangerouslySetInnerHTML={{ __html: list }} />
				</BorderedColumn>
			</FlexColumn>
		</PaddedCard>
	);
};

export default styled(MessagesCard)``;
